import { render, staticRenderFns } from "./SolutionFormModal.vue?vue&type=template&id=496a0a52"
import script from "./SolutionFormModal.vue?vue&type=script&lang=js"
export * from "./SolutionFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports